// src/hooks/useScrollTracking.js
import { useEffect } from "react";
import ReactGA from "react-ga4";

const useScrollTracking = () => {
  useEffect(() => {
    let scrollPercentages = [25, 50, 75, 90, 100];
    let trackedPercentages = new Set();

    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      const scrolled = (scrollTop / (documentHeight - windowHeight)) * 100;

      scrollPercentages.forEach((percentage) => {
        if (scrolled >= percentage && !trackedPercentages.has(percentage)) {
          ReactGA.event({
            category: "Engagement",
            action: "Scroll Depth",
            label: `Scrolled ${percentage}%`,
            value: percentage,
          });
          trackedPercentages.add(percentage);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};

export default useScrollTracking;
